import 'bee-modal/build/Modal.css'
export * from 'bee-modal';
export { default } from 'bee-modal';


// WEBPACK FOOTER //
// ./src/components/bee/modal/index.js